import { baseApi } from "@/redux/api/baseApi";
import { tagTypes } from "@/redux/tagTypes";

export interface CreateOtEnquiryRequest {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  dateOfBirth?: string;
  address?: string;
  preferredDate?: string;
  reasonForEnquiry?: string;
}

export interface CreateOtEnquiryResponse {
  success: boolean;
  message: string;
  data: {
    id: string;
    message: string;
  };
}

export const otEnquiryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createOtEnquiry: builder.mutation<CreateOtEnquiryResponse, CreateOtEnquiryRequest>({
      query: (data) => ({
        url: "/public-ot-enquiry",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.otEnquiry],
    }),
  }),
});

export const { useCreateOtEnquiryMutation } = otEnquiryApi;
